import type { Annotation } from './types';

export const mapAnnotationForGeneration = (annotation: Annotation) => ({
  type: annotation.type,
  content: annotation.content || annotation.text,
});
